/** Register the generic-shell service worker only for production builds. */
export function registerShellServiceWorker(): void {
  if (!import.meta.env.PROD || !("serviceWorker" in navigator)) {
    return;
  }

  window.addEventListener(
    "load",
    () => {
      void navigator.serviceWorker
        .register("/service-worker.js", { scope: "/", updateViaCache: "none" })
        .catch(() => undefined);
    },
    { once: true },
  );
}
